import { atom } from 'jotai';

import { UserState } from '@/hooks/use-user-state';

const UserStateAtoms = {
  user: atom<UserState | undefined>(undefined),
};

UserStateAtoms.user.debugLabel = 'UserStateAtoms.User';

export default UserStateAtoms;
